module.exports = __webpack_public_path__ + "static/media/artist_01.5ed0a6a4.jpg";